import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PrintNode_ds_get_device_associationsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { entity?: { type: string, id: string }, device_type?: string, $top?: number, $skip?: number }): Promise<{ result?: { device_type?: string, device_id?: string, id?: string, entity?: { type?: string, id?: string } }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/PrintNode/datasources/ds_get_device_associations/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { entity?: { type: string, id: string }, device_type?: string, $keys: string[] }): Promise<{ result?: { device_type?: string, device_id?: string, id?: string, entity?: { type?: string, id?: string } }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PrintNode/datasources/ds_get_device_associations/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      entity?: { type: string, id: string }, device_type?: string    }) {
      return false;
    }
}
